
angular.module(NgAppName).service('ImageService', [function() {
	this.getSmartImage = function(width = 540, height = 330, url, mode = 'fit-in', format = '') {
		let newUrl = window.thumbor_server_cdn;
		let devicePixelRatio = 1; // window.devicePixelRatio; -- don't use devicePixelRatio since images are too large in this case
		let newWidth ='';
		if (width) {
			newWidth = Math.round(devicePixelRatio * width);
		}
		let newHeight = '';
		if (height) {
			newHeight = Math.round(devicePixelRatio * height);
		} 

		let formatUrl = '';

		if ((format === 'webp' && crBrowser['support.webp']) || (format && format !== 'webp')) {
			format = `/${format}`;
			newUrl += `/${mode}/${newWidth}x${newHeight}${format}/${url}`;
		} else {
			newUrl += `/${mode}/${newWidth}x${newHeight}/${url}`;
		}

 		return newUrl;
	};

	this.getSmartImageFs = function(url, mode = 'fit-in') {
		let width = window.screen.width;
		let height = window.screen.height;
		return this.getSmartImage(width, height, url, mode);
	};
}]);
